import React from 'react';

interface FormPageLayoutProps {
	children: React.ReactNode;
	className?: string;
}

/**
 * Shared layout component for edit and create pages
 * Provides consistent max-width, padding, and overflow handling
 * Note: overflow is handled by the parent .route-cache-item container
 * Updated to support sticky headers within forms
 */
export const FormPageLayout: React.FC<FormPageLayoutProps> = ({
	children,
	className = ''
}) => {
	return (
		<div className="h-full">
			<div
				className={`form-page w-full max-w-7xl px-5 pt-6 pb-6 ${className}`}
			>
				{children}
			</div>
		</div>
	);
};
